/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type WebFilterPlacementSection = typeof WebFilterPlacementSection[keyof typeof WebFilterPlacementSection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebFilterPlacementSection = {
  MainMenu: 'MainMenu',
  SearchFilter: 'SearchFilter',
  HomePage: 'HomePage',
} as const;
